import React, { FC } from 'react'
import { translate } from 'loankeeper-common/helpers'

import { DetailsModal, constants as DCConstants } from '../DetailsContainer'

import tabs from './config'
import Footer from './Footer'

const getWindowName = (_, ID: string) => `${translate('frm_account_view-lbl_account_cap')} ${ID}`

const AccountDetailsModal: FC<{
  name: string
  ID: string
  hash: string
  disabled: boolean
}> = ({ name, ID, hash, disabled }) => (
  // @ts-ignore
  <DetailsModal
    name={name}
    disabled={disabled}
    type={DCConstants.InstanceTypes.Account}
    ID={ID}
    hash={hash}
    getWindowName={getWindowName}
    icon="account"
    tabs={tabs}
    defaultTabId="general"
    baseTabId="general"
    style={{ overflowY: 'auto' }}
    Footer={Footer}
    iconCollection="account"
  />
)

export default AccountDetailsModal
